import commaNumber from 'comma-number';

export const formatNum = (num, decimal = 2) => commaNumber(Number(num || 0).toFixed(decimal));
